import { auth } from "@/data/config/firebase-config";
import { io, Socket } from "socket.io-client";

export interface SocketInterface {
  socket: Socket;
}

export class SocketConnection implements SocketInterface {
  public declare socket: Socket;
  public declare socketEndpoint: string;

  async init(socketEndpoint: string, bearer: boolean = true) {
    this.socketEndpoint = socketEndpoint;

    this.socket = io(
      this.socketEndpoint,
      bearer
        ? {
            extraHeaders: {
              authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
            },
          }
        : {}
    );
  }

  // Function to close the socket connection
  close() {
    this.socket.disconnect();
  }
}

class SocketFactory {
  private static connections: Map<string, SocketConnection> = new Map();

  public static async create(
    socketEndpoint: string,
    bearer?: boolean
  ): Promise<SocketConnection> {
    if (!this.connections.has(socketEndpoint)) {
      const socketConnection = new SocketConnection();
      await socketConnection.init(socketEndpoint, bearer);
      console.log(`Socket endpoint created: ${socketEndpoint}`);
      this.connections.set(socketEndpoint, socketConnection);
    }
    return this.connections.get(socketEndpoint)!;
  }

  public static remove(socketEndpoint: string): void {
    const connection = this.connections.get(socketEndpoint);
    if (connection) {
      connection.close();
      this.connections.delete(socketEndpoint);
    }
  }

  public static getConnections(): Map<string, SocketConnection> {
    return this.connections;
  }
}

export default SocketFactory;
